import script from "./DrugTraceCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DrugTraceCard.vue?vue&type=script&setup=true&lang=js"

import "./DrugTraceCard.vue?vue&type=style&index=0&id=5f92b2dd&scoped=true&lang=scss"

import exportComponent from "/builds/gu1sQVEd/1/fe-huihui/fed-doctor-helper-ms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f92b2dd"]])

export default __exports__